import React, { createContext, FunctionComponent } from 'react';
import {
  useFirestore,
  useStorage,
  useAnalytics,
  useStorageDownloadURL,
} from 'reactfire';
import { logEvent } from 'firebase/analytics';
import { addDoc, collection } from '@firebase/firestore';
import { ref } from '@firebase/storage';
export interface DataAccessContextType {
  addEmail: (email: string, eventName: string) => void;
  downloadFileFromStorage: (
    filePath: string,
    fileName: string,
    eventName: string
  ) => void;
}

export const DataAccessContext = createContext<DataAccessContextType>(
  {} as DataAccessContextType
);

export interface DataAccessProviderProps {}

export const DataAccessProvider: FunctionComponent<DataAccessProviderProps> = (
  props
) => {
  const firestore = useFirestore();
  const emailCollection = collection(firestore, 'emails');
  const storage = useStorage();
  const analytics = useAnalytics();

  const downloadFile = (url: string, fileName: string): void => {
    const anchor = document.createElement('a');
    // anchor.setAttribute('target', '_blank');
    // anchor.setAttribute('target', 'noopener noreferrer');
    anchor.setAttribute('href', url);
    anchor.setAttribute('download', fileName);
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const downloadFileFromStorage = (
    filePath: string,
    fileName: string,
    eventName: string
  ): void => {
    const { status, data: url } = useStorageDownloadURL(ref(storage, filePath));

    if (status !== 'success') {
      return;
    }

    const dateTime = new Date().toJSON();
    const origin = window.location.pathname;
    logEvent(analytics, eventName, {
      dateTime,
      origin,
    });
    downloadFile(url, fileName);
  };

  const addEmail = (email: string, eventName: string): void => {
    const dateTime = new Date().toJSON();
    const origin = window.location.pathname;
    addDoc(emailCollection, {
      email,
      eventName,
      dateTime,
      origin,
    });
    logEvent(analytics, eventName, {
      dateTime,
      origin,
    });
  };

  return (
    <DataAccessContext.Provider value={{ addEmail, downloadFileFromStorage }}>
      {props.children}
    </DataAccessContext.Provider>
  );
};
